import { MeetingRoomDetailsCardBottom } from "@organisms";
import { StyledBottomContainer } from "./styles";
import { HaNCardBottomProps } from "./types";
import { MeetingRoom, RoomResource, getIsMeetingsCalendarActive } from "@lib/store";
import { useAppSelector } from "@hooks";

const isResource = (room: MeetingRoom | RoomResource): room is RoomResource => {
  return "data" in room;
};

export const HaNCardBottom = ({
  request,
  room,
  startDateTime,
  endDateTime,
  duration,
  onBookNowCallback,
  setPage,
}: HaNCardBottomProps) => {
  const isMeetingsCalendarActive = useAppSelector(getIsMeetingsCalendarActive);
  const email = isResource(room) ? room.data.email ?? "" : room.email;

  const isRoomBookable = !!email && isMeetingsCalendarActive;

  return isRoomBookable ? (
    <StyledBottomContainer>
      <MeetingRoomDetailsCardBottom
        request={request}
        room={room}
        startDateTime={startDateTime}
        duration={duration}
        onBookingDetailsPress={() => setPage("bookingDetails")}
        onBookNowCallback={onBookNowCallback}
      />
    </StyledBottomContainer>
  ) : (
    <></>
  );
};
